//import Swal from "sweetalert2";
import { endSession, generatePrimaryKey } from "./sessionUtils";
import PropTypes from "prop-types";
import Swal from "sweetalert2";

const { REACT_APP_BASE_URL } = process.env;

const Request = async (
  path,
  body = {},
  method = "GET",
  headers = {},
  isFormdata = false,
  isResponseBlob = false
) => {
  const baseHeaders = {
    Authorization: localStorage.getItem("jwt"), //TODO: Check current auth implementation
    "Access-Token": localStorage.getItem("accessToken"),
    Accept: "application/json",
    Userkey: generatePrimaryKey(),
    ...(isFormdata
      ? {}
      : {
          "Content-Type": "application/json",
        }),
  };
  let response = { ok: false };
  try {
    const reqResponse = await fetch(`${REACT_APP_BASE_URL}${path}`, {
      method,
      headers: { ...baseHeaders, ...headers },
      body: method === "GET"
        ? null
        : isFormdata
        ? body
        : JSON.stringify(body),
    });
    if (reqResponse.status === 401) {
      Swal.fire({
        icon: "warning",
        title: "Session expired",
        text: "Please log in again",
      }).then(() => {
        endSession();
      });
    } else {
      if (reqResponse.ok) {
        response = isResponseBlob
          ? await reqResponse.blob()
          : await reqResponse.json();
      } else {
        const errResponse = await reqResponse.json(); // TODO: VALIDATE BODY STRUCTURE
        return { ...response, ...errResponse };
        // Swal.fire("Error", `${errResponse.message}`, "info");
        // switch (errResponse.status) {
        //   case 400:
        //     Swal.fire({
        //       title: "Ha ocurrido un error",
        //       text: errResponse.message || "Inténtelo de nuevo",
        //       icon: "error",
        //     });
        //     break;
        //   case 401:
        //     Swal.fire({
        //       title: "Ops",
        //       text: "La sesión ha expirado, debes iniciar sesión nuevamente",
        //       icon: "warning",
        //     }).then(() => {
        //       endSession();
        //     });
        //     break;
        //   default:
        //     Swal.fire({
        //       title: "Error",
        //       text: `This happened: ${errResponse.message}`,
        //       icon: "error",
        //     });
        //     break;
        // }
      }
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Unknown error",
      text: error,
    });
  }
  return response;
};

Request.propTypes = {
  path: PropTypes.string.isRequired,
  body: PropTypes.object,
  method: PropTypes.oneOf(["GET", "POST", "PUT", "PATCH", "DELETE"]),
  isFormdata: PropTypes.bool,
  isResponseBlob: PropTypes.bool,
};

export default Request;
